<div id="container">
    <span class="title-h2">Select a variant for 
      {{jobColour.colour.carManufacturer.name}} 
      {{jobColour.colour.code}} - 
      {{jobColour.colour.name}}</span>

  <app-formula-search primaryButtonLabel="Select" (onPrimaryAction)="changeVariant($event)"></app-formula-search>
</div>